<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/industry/agent-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">基础代运营服务</div>
      </div>
      <img src="@/assets/Mobile/images/industry/base.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">增值代运营服务</div>
      </div>
      <img class="image01" src="@/assets/Mobile/images/industry/service01.png" alt="">
      <img class="image02" src="@/assets/Mobile/images/industry/service02.png" alt="">
      <img class="image03" src="@/assets/Mobile/images/industry/service03.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">增值配套服务</div>
      </div>
      <img src="@/assets/Mobile/images/industry/service04.png" alt="">
    </div>
    <Case title="代运营服务" />
    <ContactForm info-sources="代运营服务" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import Case from '@/Mobile/Mobilecom/Case'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'

export default {
  metaInfo: metaInfo.AgentOperation,
  components: {
    Case,
    ContactForm
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  img {
    width: 345px;
    margin-top: 18px;
  }
}
.block02 {
  background-color: #FAFAFA;
  .image01 {
    width: 314px;
    margin-top: 17px;
  }
  .image02 {
    width: 315px;
  }
  .image03 {
    width: 314px;
    margin-bottom: 22px;
  }
}
.block03 {
  background-color: #131A38;
  .title {
    color: #fff !important;
  }
  img {
    width: 343px;
    margin: 22px 0 27px 0;
  }
}
</style>
